import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import Navbar from "../components/marketing/Navbar";
import Footer from "../components/marketing/Footer";
import { FEATURES } from "../mock";

function Icon({ name }) {
  const C = Icons[name] || Icons.Sparkles;
  return <C size={22} className="text-coral" />;
}

export default function Features() {
  return (
    <div className="min-h-screen bg-cream">
      <Navbar />
      <section className="max-w-7xl mx-auto px-5 md:px-8 pt-16 pb-8">
        <div className="text-sm text-coral font-semibold uppercase tracking-wide">Features</div>
        <h1 className="font-display text-5xl md:text-6xl mt-3 max-w-3xl">Everything you need to run the business of your work.</h1>
        <p className="mt-4 text-[#3f4a44] max-w-2xl">From the first tracked minute to the paid invoice, Full Bench gives consulting teams a calm, complete workflow.</p>
      </section>
      <section className="max-w-7xl mx-auto px-5 md:px-8 pb-16 grid md:grid-cols-2 gap-6">
        {FEATURES.map((f) => (
          <div key={f.title} className="bg-white rounded-xl border border-cream p-8">
            <div className="h-11 w-11 rounded-md bg-cream-2 flex items-center justify-center">
              <Icon name={f.icon} />
            </div>
            <h3 className="font-display text-2xl mt-4">{f.title}</h3>
            <p className="mt-2 text-[#3f4a44]">{f.body}</p>
          </div>
        ))}
      </section>
      <section className="max-w-7xl mx-auto px-5 md:px-8 pb-20">
        <div className="rounded-2xl bg-cream-2 border border-cream p-8 md:p-12 text-center">
          <h3 className="font-display text-3xl">See it working in your workspace.</h3>
          <p className="mt-2 text-[#3f4a44]">Free for 30 days. No credit card required.</p>
          <Link to="/signup" className="btn-coral inline-block mt-6 px-6 py-3 rounded-md text-sm font-medium">Try Full Bench free</Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
